module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/duplex.js
// module id = 907
// module chunks = 0